
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      const mm = this.$gsap.matchMedia(this.$refs.container)

      mm.add('(min-width: 1024px)', () => {
        // init
        this.$gsap.set(
          [
            '.rings',
            '.outer',
            '.outer-middle',
            '.inner-middle',
            '.inner',
            '.seal-text',
          ],
          {
            transformOrigin: 'center',
          }
        )

        this.$gsap.set(['.image'], {
          opacity: 0,
        })

        // start anim
        const tl = this.$gsap.timeline()
        tl.from(
          '.outer',
          {
            rotate: 180,
            duration: 0.5,
            ease: 'easeInOut',
          },
          0
        )
        tl.from(
          '.outer-middle',
          {
            rotate: -180,
            duration: 1.5,
            ease: 'easeInOut',
          },
          0
        )
        tl.from(
          '.inner-middle',
          {
            rotate: 180,
            duration: 2.1,
            ease: 'easeInOut',
          },
          0
        )
        tl.from(
          '.inner',
          {
            rotate: -180,
            duration: 2.4,
            ease: 'easeInOut',
          },
          0
        )

        tl.from(
          '.box',
          {
            opacity: 0,
            y: 40,
            scale: 0.1,
            stagger: {
              // grid: [7, 15],
              from: 'edges',
              axis: 'x',
              amount: 1,
            },
          },
          0
        )
        tl.to(
          '.image',
          {
            opacity: 1,
            duration: 0.4,
            // stagger: {
            //   amount: 0.2,
            //   from: 'edges',
            // },
          },
          '>-=.1'
        )
        // tl.from(
        //   this.$refs.sealContainer,
        //   {
        //     // autoAlpha: 0,
        //     duration: 0.3,
        //   },
        //   '<+=.2'
        // )

        tl.from(
          '.seal-text',
          {
            opacity: 0,
            // y: 40,
            scale: 1.5,
            duration: 1.5,
            ease: 'easeInOut',
          },
          0
        )

        tl.from(
          this.$refs.sealContainer,
          {
            // /opacity: 0,
            duration: 0.5,
          },
          0
        )
        tl.from(
          this.$refs.sealContainer,
          {
            scale: 1.5,
            duration: 2,
          },
          0
        )

        // parallax
        this.$gsap
          .timeline({
            scrollTrigger: {
              scrub: true,
            },
          })
          .to('.seal', {
            y: (i, target) =>
              -this.$ScrollTrigger.maxScroll(window) * target.dataset.speed,

            ease: 'none',
          })
          .to(
            '.rings',
            {
              rotate: 360,
            },
            0
          )
        //   .to(
        //     '.inner',
        //     {
        //       rotate: 800,
        //       duration: 0.2,
        //     },
        //     0
        //   )
        //   .to('.inner-middle', { rotate: 660, duration: 0.5 }, 0)
        //   .to('.outer-middle', { rotate: 460, duration: 0.5 }, 0)
        //   .to('.outer', { rotate: 360, duration: 0.5 }, 0)
      })
    },
  },
}
